require('./brokerCustomWalletChangeDefaultModal.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ helpers
const { getFirstNChars } = require('utilities/stringHelper');

// @component
const OKModal = require('components/commons/OKModal/OKModal');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { HYPHEN } = require('constants/index');

//@ constants
const { BROKER_CUSTOM_CONFIG_WALLET_NAME_LIMIT } = require('../../constants/index');

class BrokerCustomWalletChangeDefaultModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleConfirmedChangeDefault = this.handleConfirmedChangeDefault.bind(this);
        this.handleCancelChangeDefault = this.handleCancelChangeDefault.bind(this);
    }

    buildCheckboxLabel(name, parsedCount) {
        const viewName = getFirstNChars(name, BROKER_CUSTOM_CONFIG_WALLET_NAME_LIMIT);
        return (
            <div>
                <div className="broker-custom-wallet-change-default__modal-wallet-name">
                    {viewName} {HYPHEN}
                </div>
                <div className="broker-custom-wallet-change-default__modal-wallet-count">
                    {parsedCount}
                </div>
            </div>
        );
    }

    buildCustomWallets() {
        const { handleChangeDefaultCheckboxChanged, immBrokerCustomWalletPortfolios } = this.props;
        const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');
        let idDefaultWalletPreSet = immBrokerCustomWalletPortfolios.get('idPortfolioAccountDefaultView');

        if (!idDefaultWalletPreSet) {
            idDefaultWalletPreSet = 0;
        }

        const idDefaultWalletToSet = immBrokerCustomWalletPortfolios.get('idDefaultViewToSet');
        const cancelDefaultViewModal = immBrokerCustomWalletPortfolios.get('cancelDefaultViewModal');
        let idDefaultWallet;

        if (idDefaultWalletToSet || idDefaultWalletToSet === 0) {
            idDefaultWallet = idDefaultWalletToSet;
        } else {
            idDefaultWallet = idDefaultWalletPreSet;
        }

        if (cancelDefaultViewModal) {
            idDefaultWallet = idDefaultWalletPreSet;
        }

        const idDefaultWalletParsed = parseInt(idDefaultWallet);
        const defaultWallets = (
            customWallets.map((immPortfolio) => {
                const name = immPortfolio.get('descriptionPortfolioAccount');
                const count = immPortfolio.get('count');
                const idPortfolio = immPortfolio.get('idPortfolioAccount');
                const total = this.props.totalContractsCount;
                let parsedCount = '';
                if (count) {
                    if (count == 1) {
                        parsedCount = '1 ' + formatText('brokerCustomWallet-oneVisibleContractSubtitle');
                    } else if (count == 0) {
                        parsedCount = '0 ' + formatText('brokerCustomWallet-ceroVisibleContractsSubtitle');
                    } else if (count == total) {
                        parsedCount = <FormattedText value="brokerCustomWallet-allVisibleContractsSubtitle" injectedStrings={[count]} />
                    } else {
                        parsedCount = <FormattedText value="brokerCustomWallet-someVisibleContractsSubtitle" injectedStrings={[count]} />
                    }
                }
                return (
                    <RadioButton
                        className="broker-custom-wallet-change-default__modal-wallet-checkbox"
                        key={idPortfolio}
                        value={idPortfolio}
                        label={this.buildCheckboxLabel(name, parsedCount)}
                    />
                );
            })
        );
        return (
            <RadioButtonGroup
                name="defaultPortfolio"
                idPrefix="defaultPortfolio"
                selectedValue={idDefaultWalletParsed}
                onChange={handleChangeDefaultCheckboxChanged}
            >
                {defaultWallets}
            </RadioButtonGroup>
        );
    }

    buildModalChangeDefaultConfirmation() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');
        const customWalletsParsed = this.buildCustomWallets();

        if (customWallets) {
            const modalContent = (
                <React.Fragment>
                    <div className="broker-custom-wallet-change-default__modal-text">
                        <FormattedText value="brokerCustomWallet-changeDefaultWalletText" />
                    </div>
                    <div className="broker-custom-wallet-change-default__modal-select-title">
                        <FormattedText value="brokerCustomWallet-changeDefaultWalletSelectTitle" />
                    </div>
                    <div>
                        {customWalletsParsed}
                    </div>
                </React.Fragment>
            );

            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={this.handleCancelChangeDefault}
                    onPrimaryButtonClick={this.handleConfirmedChangeDefault}
                    onSecondaryButtonClick={this.handleCancelChangeDefault}
                    primaryButtonText="brokerCustomWallet-buttonConfirmDeleteWallet"
                    secondaryButtonText="brokerCustomWallet-buttonCancelDeleteWallet"
                    size="large"
                    title="brokerCustomWallet-changeDefaultWalletTitle"
                />
            );
        }
    }

    handleCancelChangeDefault() {
        this.props.onCancelChangeDefault();
    }

    handleConfirmedChangeDefault() {
        this.props.onChangeDefaultConfirmed();
    }

    render() {
        return this.buildModalChangeDefaultConfirmation();
    }
}

BrokerCustomWalletChangeDefaultModal.propTypes = {
    immBrokerCustomWalletPortfolios: PropTypes.object.isRequired,
    onChangeDefaultConfirmed: PropTypes.func.isRequired,
    onCancelChangeDefault: PropTypes.func.isRequired,
    handleChangeDefaultCheckboxChanged: PropTypes.func,
    totalContractsCount: PropTypes.number
};

module.exports = BrokerCustomWalletChangeDefaultModal;
